import dynamic from 'next/dynamic'
import { Box } from 'theme-ui'

import type { SxProp } from 'theme-ui'
import type { SVGProps } from 'react'
import type { WithChildren } from 'src/types/utils'

export type IconVariant = keyof typeof Icons

type ComponentProps = SxProp & SVGProps<SVGSVGElement> & WithChildren

const Icons = {
  GelIconArrowDown: dynamic(() => import('../icons/arrows/GelIconArrowDown')),
  GelIconArrowRight: dynamic(() => import('../icons/arrows/GelIconArrowRight')),
  GelIconChevronDown: dynamic(() => import('../icons/arrows/GelIconChevronDown')),
  GelIconChevronLeft: dynamic(() => import('../icons/arrows/GelIconChevronLeft')),
  GelIconChevronRight: dynamic(() => import('../icons/arrows/GelIconChevronRight')),
  GelIconChevronUp: dynamic(() => import('../icons/arrows/GelIconChevronUp')),
  GelIconAdd: dynamic(() => import('../icons/actions/GelIconAdd')),
  GelIconDownload: dynamic(() => import('../icons/actions/GelIconDownload')),
  GelIconClose: dynamic(() => import('../icons/actions/GelIconClose')),
  GelIconListViewText: dynamic(() => import('../icons/actions/GelIconListViewText')),
  GelIconExternalLink: dynamic(() => import('../icons/actions/GelIconExternalLink'))
}

export interface IconProps extends ComponentProps {
  variant: IconVariant
}

const Icon = ({ variant, sx, ...rest }: IconProps) => {
  const IconComponent = Icons[variant]
  return (
    <Box sx={sx as any} as="span">
      <IconComponent {...rest} />
    </Box>
  )
}

export default Icon
